export const dollarIcon = (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.09712 0.251953C0.84551 0.251953 0.60421 0.351903 0.426299 0.529814C0.248387 0.707726 0.148438 0.949026 0.148438 1.20063V13.0064C0.148438 13.5306 0.572883 13.9551 1.09712 13.9551H12.9029C13.0275 13.9551 13.1508 13.9305 13.2659 13.8829C13.381 13.8352 13.4856 13.7653 13.5737 13.6772C13.6618 13.5891 13.7317 13.4845 13.7793 13.3694C13.827 13.2543 13.8516 13.131 13.8516 13.0064V1.20063C13.8516 1.07605 13.827 0.952687 13.7793 0.837588C13.7317 0.722489 13.6618 0.617907 13.5737 0.529814C13.4856 0.441721 13.381 0.371843 13.2659 0.324167C13.1508 0.276491 13.0275 0.251953 12.9029 0.251953H1.09712ZM7.52704 2.53581C7.52704 2.39603 7.47152 2.26197 7.37268 2.16313C7.27384 2.06429 7.13978 2.00876 7 2.00876C6.86022 2.00876 6.72616 2.06429 6.62732 2.16313C6.52848 2.26197 6.47296 2.39603 6.47296 2.53581V3.31091C6.11105 3.36502 5.75618 3.49011 5.45611 3.71779C4.98318 4.07618 4.71615 4.63203 4.71615 5.3467C4.71615 5.69526 4.79626 6.00352 4.95648 6.27149C5.11459 6.53571 5.33173 6.73037 5.56433 6.87864C5.9944 7.15271 6.54323 7.30168 6.99719 7.42536L7.03724 7.43661C7.5425 7.57434 7.93954 7.68748 8.22133 7.86667C8.35134 7.9496 8.43567 8.03463 8.48978 8.12457C8.54107 8.21101 8.58113 8.32977 8.58113 8.50896C8.58113 8.93763 8.40896 9.20607 8.15668 9.38245C7.88262 9.57429 7.47856 9.679 7.01827 9.66284C6.31555 9.63684 5.64444 9.33677 5.31346 8.89546C5.27193 8.84009 5.21991 8.79344 5.16035 8.75818C5.1008 8.72292 5.03488 8.69973 4.96636 8.68994C4.89785 8.68015 4.82807 8.68396 4.76102 8.70113C4.69398 8.71831 4.63097 8.74853 4.5756 8.79005C4.52023 8.83158 4.47358 8.88361 4.43832 8.94316C4.40306 9.00272 4.37987 9.06864 4.37008 9.13715C4.36029 9.20567 4.3641 9.27544 4.38127 9.34249C4.39845 9.40954 4.42866 9.47254 4.47019 9.52791C4.94102 10.1554 5.70488 10.5293 6.47296 10.6628V11.6712C6.47296 11.811 6.52848 11.9451 6.62732 12.0439C6.72616 12.1427 6.86022 12.1983 7 12.1983C7.13978 12.1983 7.27384 12.1427 7.37268 12.0439C7.47152 11.9451 7.52704 11.811 7.52704 11.6712V10.6937C7.96835 10.641 8.39983 10.4998 8.76103 10.2461C9.29299 9.87366 9.63522 9.28337 9.63522 8.50896C9.63522 8.16041 9.55511 7.85215 9.39488 7.58418C9.24341 7.33636 9.03503 7.12822 8.78703 6.97703C8.35696 6.70296 7.80813 6.55398 7.35417 6.43031L7.31412 6.41906C6.80886 6.28133 6.41182 6.16819 6.13003 5.98899C6.02087 5.92618 5.92872 5.83765 5.86159 5.73109C5.79608 5.61392 5.76445 5.48083 5.77023 5.3467C5.77023 4.91523 5.9178 4.68966 6.09208 4.55825C6.28884 4.40927 6.59523 4.32283 6.98594 4.33338C7.65283 4.35165 8.36399 4.64539 8.73573 5.01642C8.78398 5.06821 8.84216 5.10974 8.90682 5.13854C8.97147 5.16735 9.04126 5.18284 9.11202 5.18409C9.18279 5.18534 9.25308 5.17232 9.31871 5.14581C9.38433 5.1193 9.44395 5.07985 9.49399 5.0298C9.54404 4.97976 9.5835 4.92014 9.61 4.85452C9.63651 4.78889 9.64953 4.7186 9.64828 4.64783C9.64703 4.57706 9.63154 4.50727 9.60274 4.44262C9.57393 4.37797 9.5324 4.31979 9.48062 4.27154C9.00136 3.79158 8.2642 3.45427 7.52704 3.32989V2.53581Z"
      fill="#240B3B"
    />
  </svg>
);

export const steakIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_845_1997)">
      <path
        d="M12.5756 1.64589C12.5756 1.64589 3.42784 1.64284 3.43047 1.64589C2.58728 1.64589 2.11328 2.11815 2.11328 3.08279V13.029C2.11328 13.9315 2.53947 14.404 3.38191 14.404H12.6018C13.4443 14.404 13.871 13.9551 13.871 13.029V3.08279C13.8712 2.14151 13.4445 1.64589 12.5756 1.64589ZM7.76397 6.24768C7.76397 6.55968 7.50166 6.89382 7.16116 6.89382V12.1619C7.16116 12.9098 6.22028 12.9098 6.22028 12.1619V6.89382C5.88897 6.89382 5.60041 6.61737 5.60041 6.2032V3.30399C5.60041 3.05171 5.93697 3.04196 5.93697 3.31395V5.45692H6.21878V3.29404C6.21878 3.06228 6.54297 3.04745 6.54297 3.30399V5.45692H6.83416V3.29709C6.83416 3.05476 7.14878 3.04501 7.14878 3.30664V5.45692H7.43528V3.29709C7.43528 3.0574 7.76397 3.04785 7.76397 3.30664V6.24768ZM10.2738 12.1594C10.2738 12.8909 9.33109 12.8799 9.33109 12.1594V8.91309H8.82916V3.97776C8.82916 2.82889 10.274 2.82889 10.274 3.97776V12.1594H10.2738Z"
        fill="#240B3B"
      />
    </g>
    <defs>
      <clipPath id="clip0_845_1997">
        <rect
          width="12"
          height="13"
          fill="white"
          transform="translate(2 1.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const wifiIcon = (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 8.58047C8.025 6.2388 11.975 6.2388 15 8.58047"
      stroke="#101010"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.33203 11.1557C8.55703 9.439 11.4487 9.439 13.6737 11.1557"
      stroke="#101010"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.16797 13.7307C9.2763 12.8723 10.7263 12.8723 11.8346 13.7307"
      stroke="#101010"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5013 18.6134H12.5013C16.668 18.6134 18.3346 16.9468 18.3346 12.7801V7.78011C18.3346 3.61344 16.668 1.94678 12.5013 1.94678H7.5013C3.33464 1.94678 1.66797 3.61344 1.66797 7.78011V12.7801C1.66797 16.9468 3.33464 18.6134 7.5013 18.6134Z"
      stroke="#101010"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const breakfastIcon = (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.8263 9.0054V15.1054C14.8263 17.0471 13.2513 18.6137 11.318 18.6137H5.1763C3.24297 18.6137 1.66797 17.0387 1.66797 15.1054V9.0054C1.66797 7.06374 3.24297 5.49707 5.1763 5.49707H11.318C13.2513 5.49707 14.8263 7.07207 14.8263 9.0054Z"
      stroke="#101010"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.58203 3.61361V2.15527"
      stroke="#101010"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.91797 3.61361V2.15527"
      stroke="#101010"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.25 3.61361V2.15527"
      stroke="#101010"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.3326 11.2471C18.3326 13.1804 16.7576 14.7554 14.8242 14.7554V7.73877C16.7576 7.73877 18.3326 9.30544 18.3326 11.2471Z"
      stroke="#101010"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.66797 10.2803H14.593"
      stroke="#101010"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const checkIcon = (
  <svg
    width="12"
    height="13"
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5 3.9301L4.5 9.9301L1.75 7.1801L2.455 6.4751L4.5 8.5151L9.795 3.2251L10.5 3.9301Z"
      fill="#41245C"
    />
  </svg>
);

export const locationIcon = (
  <svg
    width="16"
    height="20"
    viewBox="0 0 16 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_862_2091)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 0C12.4183 0 16 3.58172 16 8C16 10.8133 13.5667 14.59 8.7 19.33C8.31116 19.7111 7.68884 19.7111 7.3 19.33C2.43333 14.59 0 10.8133 0 8C0 3.58172 3.58172 0 8 0ZM8 2C4.68629 2 2 4.68629 2 8C2 9.21 2.8 12 8 17.21C13.2 12 14 9.21 14 8C14 4.68629 11.3137 2 8 2ZM8 5C9.65685 5 11 6.34315 11 8C11 9.65685 9.65685 11 8 11C6.34315 11 5 9.65685 5 8C5 6.34315 6.34315 5 8 5ZM8 7C7.44772 7 7 7.44772 7 8C7 8.55228 7.44772 9 8 9C8.55228 9 9 8.55228 9 8C9 7.44772 8.55228 7 8 7Z"
        fill="#2D333F"
      />
    </g>
    <defs>
      <clipPath id="clip0_862_2091">
        <rect width="16" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const neighborhoodIcon = (
  <svg
    width="22"
    height="20"
    viewBox="0 0 22 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.60319 4.40305C9.65406 3.62069 10.0852 2.90828 10.7631 2.50153L14.3624 0.34195C15.1223 -0.113983 16.0716 -0.113983 16.8315 0.34195L20.4308 2.50153C21.1536 2.93518 21.5958 3.71624 21.5958 4.55911V17.5977C21.5958 18.9229 20.5215 19.9972 19.1963 19.9972H9.71429C9.6758 19.9991 9.63707 20 9.59813 20H2.39953C1.07431 20 0 18.9257 0 17.6005V6.80258C0 5.47735 1.07431 4.40305 2.39953 4.40305H9.59813L9.60319 4.40305ZM9.59813 6.80258H2.39953V17.6005H9.59813V6.80258ZM11.9977 4.40305V17.6006H19.1963V4.40305L15.597 2.0964L11.9977 4.40305ZM5.39895 9.20211H6.59871C6.93002 9.20211 7.19859 9.47069 7.19859 9.80199V11.0018C7.19859 11.3331 6.93002 11.6016 6.59871 11.6016H5.39895C5.06764 11.6016 4.79906 11.3331 4.79906 11.0018V9.80199C4.79906 9.47069 5.06764 9.20211 5.39895 9.20211ZM5.39895 12.8014H6.59871C6.93002 12.8014 7.19859 13.07 7.19859 13.4013V14.6011C7.19859 14.9324 6.93002 15.2009 6.59871 15.2009H5.39895C5.06764 15.2009 4.79906 14.9324 4.79906 14.6011V13.4013C4.79906 13.07 5.06764 12.8014 5.39895 12.8014ZM14.9971 9.20211H16.1968C16.5281 9.20211 16.7967 9.47069 16.7967 9.80199V11.0018C16.7967 11.3331 16.5281 11.6016 16.1968 11.6016H14.9971C14.6658 11.6016 14.3972 11.3331 14.3972 11.0018V9.80199C14.3972 9.47069 14.6658 9.20211 14.9971 9.20211ZM14.9971 12.8014H16.1968C16.5281 12.8014 16.7967 13.07 16.7967 13.4013V14.6011C16.7967 14.9324 16.5281 15.2009 16.1968 15.2009H14.9971C14.6658 15.2009 14.3972 14.9324 14.3972 14.6011V13.4013C14.3972 13.07 14.6658 12.8014 14.9971 12.8014ZM14.9971 5.60281H16.1968C16.5281 5.60281 16.7967 5.87139 16.7967 6.20269V7.40246C16.7967 7.73377 16.5281 8.00234 16.1968 8.00234H14.9971C14.6658 8.00234 14.3972 7.73377 14.3972 7.40246V6.20269C14.3972 5.87139 14.6658 5.60281 14.9971 5.60281Z"
      fill="#2D333F"
    />
  </svg>
);

export const cuisinIcon = (
  <svg
    width="16"
    height="20"
    viewBox="0 0 16 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_861_2054)">
      <path
        d="M7 0C8.10457 0 9 0.89543 9 2V9C9 10.1046 8.10457 11 7 11H6V19C6 19.5523 5.55228 20 5 20H4C3.44772 20 3 19.5523 3 19V11H2C0.89543 11 0 10.1046 0 9V2C0 0.89543 0.89543 0 2 0H7ZM7 9V2H6V6.5C6 6.77614 5.77614 7 5.5 7C5.22386 7 5 6.77614 5 6.5V2H4V6.5C4 6.77614 3.77614 7 3.5 7C3.22386 7 3 6.77614 3 6.5V2H2V9H7ZM15.45 0C15.7538 0 16 0.246243 16 0.55V19C16 19.5523 15.5523 20 15 20H14C13.4477 20 13 19.5523 13 19V15H12C10.8954 15 10 14.1046 10 13V5.45C10 2.44005 12.44 0 15.45 0ZM12 13H14V2.32C12.7823 2.88673 12.0027 4.10692 12 5.45V13Z"
        fill="#240B3B"
      />
    </g>
    <defs>
      <clipPath id="clip0_861_2054">
        <rect width="16" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const diningIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 20V18H5C4.44772 18 4 17.5523 4 17V16.5C4 16.2239 4.22386 16 4.5 16H19.5C19.7761 16 20 16.2239 20 16.5V17C20 17.5523 19.5523 18 19 18H13V20H14.5C14.7761 20 15 20.2239 15 20.5V21.5C15 21.7761 14.7761 22 14.5 22H9.5C9.22386 22 9 21.7761 9 21.5V20.5C9 20.2239 9.22386 20 9.5 20H11ZM9.00417 5.40358C9.0014 5.34651 9 5.28914 9 5.23151C9 3.4468 10.3431 2 12 2C13.6569 2 15 3.4468 15 5.23151C15 5.28914 14.9986 5.34652 14.9958 5.4036C18.4009 6.45157 20.0249 9.56291 19.9997 15H4.00029C3.97503 9.56288 5.59906 6.45153 9.00417 5.40358ZM11.0649 5.03309C11.3666 5.011 11.6783 5 12 5C12.3217 5 12.6334 5.011 12.9351 5.0331C12.9775 4.90683 13 4.7711 13 4.63103C13 4.00638 12.5523 3.5 12 3.5C11.4477 3.5 11 4.00638 11 4.63103C11 4.7711 11.0225 4.90683 11.0649 5.03309ZM17.9998 13C18.0236 8.89548 16.0893 7 12 7C7.91067 7 5.97638 8.89548 6.00022 13H17.9998Z"
      fill="#2D333F"
    />
  </svg>
);

export const paymentIcon = (
  <svg
    width="20"
    height="16"
    viewBox="0 0 20 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 4V2H2V4H18ZM18 8H2V14H18V8ZM2 0H18C19.1046 0 20 0.89543 20 2V14C20 15.1046 19.1046 16 18 16H2C0.89543 16 0 15.1046 0 14V2C0 0.89543 0.89543 0 2 0Z"
      fill="#2D333F"
    />
  </svg>
);

export const parkingIcon = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18ZM9 16C12.866 16 16 12.866 16 9C16 5.13401 12.866 2 9 2C5.13401 2 2 5.13401 2 9C2 12.866 5.13401 16 9 16ZM6.5 4.97771C6.5 4.85871 6.596 4.74971 6.728 4.74971H9.546C11.021 4.74971 12.233 5.94871 12.233 7.40071C12.233 8.88771 11.021 10.0997 9.558 10.0997H8.059V12.9177C8.059 13.0367 7.951 13.1457 7.831 13.1457H6.728C6.596 13.1457 6.5 13.0367 6.5 12.9177V4.97771ZM9.498 8.63571C10.17 8.63571 10.685 8.09671 10.685 7.38871C10.685 6.72971 10.17 6.22571 9.498 6.22571H8.059V8.63571H9.498Z"
      fill="#2D333F"
    />
  </svg>
);

export const additionalIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.1517 3.57491L15.4253 2.57829C15.8385 2.45247 16.3026 2.57604 16.624 2.89747L21.3053 7.57877C21.6291 7.90255 21.7519 8.37085 21.6219 8.78593L20.578 12.1191L11.2794 21.4177C10.8401 21.857 10.104 21.8333 9.63539 21.3647L2.84717 14.5764C2.37854 14.1078 2.3548 13.3718 2.79414 12.9324L12.1517 3.57491ZM13.3123 5.24264L4.82707 13.7279L10.4839 19.3848L18.9692 10.8995L19.6763 8.77817L15.4337 4.53553L13.3123 5.24264ZM16.1408 8.07107C16.9218 8.85212 16.9218 10.1184 16.1408 10.8995C15.3597 11.6805 14.0934 11.6805 13.3123 10.8995C12.5313 10.1184 12.5313 8.85212 13.3123 8.07107C14.0934 7.29002 15.3597 7.29002 16.1408 8.07107Z"
      fill="#2D333F"
    />
  </svg>
);
